import React from 'react';

import BriefcaseIcon from '@buyside/svgs/briefcase.svg';
import JobVaultCard from './JobVaultCard/jobVaultCard';
import Link from '@buyside/components/presentation/Link/link';

import { jobVaultPostingUrl } from '@buyside/util/urlHelper';
import { vowelCheck } from '@buyside/util/textHelpers';

import { ActivityFeedJobPostingFragment } from '@interfaces/graphql-typings';
import { FeedItemComponentType } from '@interfaces/feed/feedItems';

import styles from './jobVaultStyles.scss';

const JobVault: React.FC<{
  jobPosting: ActivityFeedJobPostingFragment;
} & FeedItemComponentType> = ({ jobPosting, eventVerb }) => {
  const { id, title } = jobPosting;

  const newJob = eventVerb === 'PUBLISH_JOB_POSTING';

  if (!newJob && eventVerb !== 'FILL_JOB_POSTING') {
    return null;
  }

  return (
    <div className={styles.jobVaultFeedItem}>
      {(newJob && (
        <div className={styles.jobVaultHeader}>
          <Link to={jobVaultPostingUrl(id)} className={styles.jobLink}>
            <BriefcaseIcon className={styles.jobIcon} />A New Position
          </Link>{' '}
          is now available on the SumZero Job Vault
        </div>
      )) || (
        <div className={styles.jobVaultHeader}>
          <strong className={styles.jobLink}>
            <BriefcaseIcon className={styles.jobIcon} />A{vowelCheck(title[0]) ? 'n' : ''} {title}{' '}
            Position
          </strong>{' '}
          has been filled by a SumZero Member:
        </div>
      )}
      <JobVaultCard eventVerb={eventVerb} jobPosting={jobPosting} />
    </div>
  );
};

export default JobVault;
